var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1914_4058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 4.77431V21.6C20.9999 22.9255 19.9254 24 18.5999 24H5.4C4.07452 24 3 22.9255 3 21.6V2.4C3 1.07452 4.07452 0 5.4 0H15.802L20.9999 4.77431Z",
    fill: "url(#paint0_linear_1914_4058)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1914_4058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9996 4.77431H16.4018C16.0704 4.77431 15.8018 4.50568 15.8018 4.17431V0L20.9996 4.77431Z",
    fill: "#ABEFC6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.92827 19.3994L7.47527 16.9144L5.90727 14.4994H6.99927L8.07727 16.1724L9.06427 14.4994H10.1283L8.59527 16.9564L10.1703 19.3994H9.07827L7.99327 17.6984L6.99927 19.3994H5.92827ZM10.8697 19.3994V14.4994H11.8147V18.6644H13.9637V19.3994H10.8697ZM16.2481 19.4834C15.8935 19.4834 15.5761 19.4227 15.2961 19.3014C15.0208 19.1801 14.8015 19.0027 14.6381 18.7694C14.4795 18.5361 14.3978 18.2537 14.3931 17.9224H15.3941C15.3988 18.0671 15.4361 18.1977 15.5061 18.3144C15.5761 18.4311 15.6718 18.5244 15.7931 18.5944C15.9191 18.6597 16.0685 18.6924 16.2411 18.6924C16.3905 18.6924 16.5188 18.6691 16.6261 18.6224C16.7381 18.5711 16.8245 18.5011 16.8851 18.4124C16.9458 18.3237 16.9761 18.2187 16.9761 18.0974C16.9761 17.9574 16.9411 17.8407 16.8711 17.7474C16.8058 17.6541 16.7125 17.5747 16.5911 17.5094C16.4745 17.4441 16.3368 17.3857 16.1781 17.3344C16.0241 17.2784 15.8608 17.2201 15.6881 17.1594C15.3008 17.0334 15.0045 16.8654 14.7991 16.6554C14.5985 16.4454 14.4981 16.1677 14.4981 15.8224C14.4981 15.5284 14.5681 15.2764 14.7081 15.0664C14.8528 14.8564 15.0511 14.6954 15.3031 14.5834C15.5551 14.4714 15.8421 14.4154 16.1641 14.4154C16.4955 14.4154 16.7848 14.4737 17.0321 14.5904C17.2841 14.7024 17.4825 14.8657 17.6271 15.0804C17.7765 15.2951 17.8535 15.5471 17.8581 15.8364H16.8501C16.8455 15.7291 16.8128 15.6287 16.7521 15.5354C16.6961 15.4374 16.6168 15.3604 16.5141 15.3044C16.4115 15.2437 16.2901 15.2134 16.1501 15.2134C16.0288 15.2087 15.9168 15.2274 15.8141 15.2694C15.7161 15.3114 15.6368 15.3744 15.5761 15.4584C15.5201 15.5377 15.4921 15.6381 15.4921 15.7594C15.4921 15.8761 15.5201 15.9741 15.5761 16.0534C15.6368 16.1327 15.7185 16.2027 15.8211 16.2634C15.9238 16.3194 16.0451 16.3731 16.1851 16.4244C16.3251 16.4711 16.4768 16.5201 16.6401 16.5714C16.8828 16.6554 17.1068 16.7557 17.3121 16.8724C17.5175 16.9844 17.6808 17.1314 17.8021 17.3134C17.9235 17.4954 17.9841 17.7357 17.9841 18.0344C17.9841 18.2911 17.9165 18.5291 17.7811 18.7484C17.6458 18.9677 17.4498 19.1451 17.1931 19.2804C16.9411 19.4157 16.6261 19.4834 16.2481 19.4834Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1914_4058",
    x: 14.0018,
    y: -0.6,
    width: 7.59824,
    height: 7.17441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.6,
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1914_4058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1914_4058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1914_4058",
    x1: 18,
    y1: 2,
    x2: 2,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FCE7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1914_4058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.f06b3e58375e700fd5866ffeb538a30b.svg";
export { ForwardRef as ReactComponent };